var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVasThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 53,
    viewBox: "0 0 29 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.50879,
    width: 28.1049,
    height: 46.4912,
    rx: 14.0525,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.50879,
    width: 26.1049,
    height: 44.4912,
    rx: 13.0525,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1758,
    y: 16.7373,
    width: 1.75656,
    height: 26.9649,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3555 4.40436L10.5669 1.72051C9.91837 1.09629 10.3602 0 11.2604 0H16.8376C17.7377 0 18.1796 1.09629 17.531 1.72051L14.7424 4.40437C14.3552 4.77702 13.7427 4.77702 13.3555 4.40436Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVasThumb);
export default __webpack_public_path__ + "static/media/vas_thumb.de2a1699962619254947b02517e56ef6.svg";
export { ForwardRef as ReactComponent };